export default "__VITE_ASSET__f9abc8ce__"